module.exports = __webpack_public_path__ + "img/1451665197.10ceab60.jpg";